const initialState = {
  mahallalar: false,
  mahalla_coordinate: false,
  mahalla_dash: false
}

const mahallalar = (state = initialState, action) => {
  switch (action.type) {
    case "MAHALLALAR":
      return { ...state, mahallalar: action.val }
    case "MAHALLA_COORDINATE":
      return { ...state, mahalla_coordinate: action.val }
    case "MAHALLA_DASHBOARD":
      return { ...state, mahalla_dash: action.val }
    default:
      return state
  }
}

export default mahallalar
